<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on }">
                <v-btn
                    id="modal-btn" 
                    fab
                    small
                    color="primary"
                    v-on="on">
                    <img  src="@/assets/icon-editar.svg" alt="">
                </v-btn>
            </template>
            <v-form ref="form">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ this.$t("message.remissionTitle") }}</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm12 md>
                                    <v-text-field
                                        :label="remissionText"
                                        v-model="remissionNo"
                                        :rules="valueDocRules"
                                        required>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <small style="color: red;">* {{ this.$t("message.dialogRequiredFields") }}</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click="dialog = false">{{ this.$t("message.dialogBtnClose") }}</v-btn>
                        <v-btn color="blue darken-1" flat @click="updateRelatedDoc()">{{ this.$t("message.dialogBtnSave") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-layout>
</template>
  
<script>
import { i18n } from "@/utils/locales/default";
import { events, printList } from "@/main";

export default {
    props: [ 'document', 'supplierCode', 'remission' ],
    data() {
        return {
            dialog: false,
            remissionTitle: this.$t("message.remissionTitle"),
            dialogValidationText: this.$t("message.dialogValidationText"),
            remissionNo: this.remission.value,
            remissionText: this.$t("message.remissionText"),
            valueDocRules: [
                v => !!v || this.dialogValidationText,
            ],
            validForm: false,
        }
    },
    methods: {
        updateRelatedDoc() {

            const body = { document: this.document, supplierCode: this.supplierCode, isRemission: true, remissionNo: this.remissionNo };

            this.$http.put(`Documents/relatedDoc/${ this.document.id }`, body )
                .then( response => {

                const { document: respDoc } = response.body;

                this.document.status = respDoc.status;
                this.snackbar( this.$t( 'message.relatedDocAssignedMessage' ) );
            }, error => {
                console.log(error);
                this.snackbar( this.$t( 'message.relatedDocErrorMessage' ) );
            });

            this.dialog = false;
        },
        snackbar: ( message ) => {
            events.$emit( "snackbar", message );
        },
    },
    mounted() {
    }
}
</script>
  
<style>
#modal-btn {
    width: 100% !important;
    height: 30px !important;
}
</style>